import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "41",
  fill: "none",
  viewBox: "0 0 40 41"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA73",
  d: "M20 0C8.75 0 .313 9.375 0 20v3.125C0 24.219.781 25 1.797 25c.937 0 1.953-.781 1.953-1.875V20c0-8.906 7.266-16.172 16.25-16.172 8.906 0 16.25 7.266 16.25 16.172v11.25c0 1.797-1.406 3.125-3.125 3.125h-8.672c-.625-1.094-1.875-1.875-3.203-1.875h-2.422c-1.797 0-3.437 1.25-3.828 3.047C14.61 37.969 16.406 40 18.672 40h2.578c1.328 0 2.578-.703 3.203-1.875h8.672c3.75 0 6.875-3.047 6.875-6.875V20C39.61 9.375 31.172 0 20 0"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#DBA100",
  d: "M12.422 15H11.25c-2.812 0-5 2.266-5 5.078v3.672c0 2.813 2.188 5 5 5h1.25c1.328 0 2.5-1.094 2.5-2.5l-.078-8.75c0-1.328-1.094-2.5-2.5-2.5m16.328 0H27.5c-1.406 0-2.5 1.172-2.5 2.578v8.672c0 1.406 1.094 2.5 2.5 2.5h1.25c2.734 0 5-2.187 5-5v-3.672c0-2.812-2.266-5.078-5-5.078"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }